/**
 * @param imageId
 * @returns ok message to connect pusher with orderID
 */
const getUpscalePhotoApi = async (imageId: string, payload: { to_be_labeled: boolean; custom_logo: boolean }) => {
    return await useApi().post(`/order/image/${imageId}/download/upscale`, {
        body: {
            ...payload,
        },
    });
};

/**
 * @description get image single
 * @param imageId
 * @returns ok message to connect pusher with orderID
 */
const getImageSingle = async (imageId: string) => {
    return await useApi().post(`/order/image/${imageId}`);
};

const fetchDownloadNormalLink = async (imageId: string, payload: { to_be_labeled: boolean; custom_logo: boolean }) => {
    return await useApi().post(`/order/image/${imageId}/download/normal`, {
        body: {
            ...payload,
        },
    });
};

export { fetchDownloadNormalLink, getImageSingle, getUpscalePhotoApi };
